export default __webpack_public_path__ + "static/media/subtle-facet.9f669a80.png";